import React, { useState, useEffect } from 'react';
import { DatePicker, Typography } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_TW';

const { RangePicker } = DatePicker;

export default function TradeDateFilter({ setFilter }) {
  const [startAndEndTime, setStartAndEndTime] = useState(null);

  useEffect(() => {
    setFilter((prevFilter) => {
      const newFilter = { ...prevFilter };
      delete newFilter.tradeDate;
      if (startAndEndTime) {
        newFilter.tradeDate = {
          $gte: startAndEndTime[0].startOf('day').valueOf(),
          $lte: startAndEndTime[1].endOf('day').valueOf(),
        };
      }
      return newFilter;
    });
  }, [setFilter, startAndEndTime]);

  const handleStartAndEndTimeChange = (value) => {
    if (value) {
      setStartAndEndTime(value);
    } else {
      setStartAndEndTime(null);
    }
  };

  return (
    <>
      <Typography.Text>交易日期：</Typography.Text>
      <RangePicker
        value={startAndEndTime}
        onChange={handleStartAndEndTimeChange}
        style={{ width: '250px' }}
        locale={locale}
      />
    </>
  );
}
